<template>
  <div class="menu-side">
    <div class="d-grid">
      <router-link
        :to="{ name: 'staffs' }"
        class="btn btn-light"
        :event="''"
        @click.native="toggleStaffs(null)"
        v-translate
      >
        All Staffs
      </router-link>
      <div class="staff-out-in">
        <router-link
          :to="{ path: '/staffs-out' }"
          class="btn btn-light"
          :event="''"
          @click.native="toggleStaffs(false)"
          v-translate
        >
          Out
        </router-link>
        <router-link
          :to="{ path: '/staffs-in' }"
          class="btn btn-light"
          :event="''"
          @click.native="toggleStaffs(true)"
          v-translate
        >
          In
        </router-link>
      </div>
    </div>
    <div class="d-grid">
      <toggle-router-link
        :toRouteName="'pay-commission'"
        :className="'btn btn-light'"
        :redirectCondition="[can('payCommission')]"
        :errorMessage="[$gettext('Permission denied')]"
        v-translate
      >
        Pay Comm.
      </toggle-router-link>
      <toggle-router-link
        :toRouteName="'stock-delivery'"
        :className="'btn btn-light'"
        :redirectCondition="[can('updateStock')]"
        :errorMessage="[$gettext('Permission denied')]"
        v-translate
      >
        Stock Delivery
      </toggle-router-link>
      <toggle-router-link
        :toRouteName="'do-payment'"
        :className="'btn btn-light'"
        :redirectCondition="[can('addPayment'), shift]"
        :errorMessage="[
          $gettext('Permission denied'),
          $gettext('Please start shift'),
        ]"
        v-translate
      >
        Do payment
      </toggle-router-link>
      <toggle-router-link
        :toRouteName="'add-staff'"
        :className="'btn btn-light'"
        :redirectCondition="[can('addCustomer'), !user.location.useLocalServer]"
        :errorMessage="[$gettext('Permission denied')]"
        :disabled="user.location.useLocalServer"
        v-translate
      >
        Add staff
      </toggle-router-link>
      <toggle-router-link
        :toRouteName="'bills-reprint'"
        :className="'btn btn-light'"
        :redirectCondition="[isCashier]"
        :errorMessage="[$gettext('Permission denied')]"
        v-translate
      >
        Reprint bill
      </toggle-router-link>
      <button
        v-show="isCashier"
        class="btn btn-light"
        @click="printArticleLocation"
        v-translate
      >
        Print Articles
      </button>

      <button
        v-show="shift"
        class="btn btn-light"
        @click="endShift"
        v-translate
      >
        End of shift
      </button>
      <button
        v-show="!shift"
        class="btn btn-light"
        @click="startShift"
        v-translate
      >
        Start of shift
      </button>
      <button
        v-show="workDay"
        class="btn btn-light"
        @click="endDay"
        v-translate
      >
        End of day
      </button>
      <button
        v-show="!workDay"
        class="btn btn-light"
        @click="confirmStartDay"
        v-translate
      >
        Start of day
      </button>
      <button
        type="button"
        class="btn btn-light"
        @click="$store.dispatch('logout')"
        v-translate
      >
        Log out
      </button>
      <toggle-router-link
        :toRouteName="'cash-calc'"
        :className="'btn btn-light'"
        :redirectCondition="[isCashier]"
        :errorMessage="[$gettext('Permission denied')]"
        @click="resetCurrentShift"
        v-translate
      >
        Cash Calc
      </toggle-router-link>
    </div>
    <portal to="bodyModalOption">
      <modal-option
        v-show="isModalPrintArticleVisible"
        @cancelModalOption="cancelModalPrintArticle"
        :options="printArticleOptions"
        :message="printArticleMessage"
        @callback = "optionSelected"
      />
    </portal>
  </div>
</template>

<script>
import { mapState, mapMutations, mapActions } from "vuex";
import DayService from "@/services/DayService";
import ToggleRouterLink from "@/components/ToggleRouterLink.vue";
import { Portal, PortalTarget, MountingPortal } from "portal-vue";

import {
  SET_SHIFT_CURRENT_ACTION,
  START_DAY,
  TOGGLE_MENU_SIDE,
  SET_MESSAGE_MODAL,
  SET_CONFIRM_MODAL,
} from "@/store/mutation-types";
import ArticleService from "../services/ArticleService";
import ModalOption from "./ModalOption.vue";
export default {
  name: "MenuSide",
  components: {
    ToggleRouterLink,
    ModalOption,
    Portal,
    PortalTarget,
    MountingPortal,
  },
  data() {
    return {
      isModalPrintArticleVisible: false,
      messagePrintArticle:
        "Please select if the report should be printed from the location or this station",

    };
  },
  computed: {
    ...mapState({
      workDay: (state) => state.auth.user.workDay,
      shift: (state) => state.auth.user.shift,
      user: (state) => state.auth.user,
    }),
    printArticleMessage() {
      return this.$gettext("Print for " + this.user.station.name + " or all");
    },
    printArticleOptions() {
      return [
        {
          label: this.user.station.name,
          emitEvent: "cashierSelected",
        },
        {
          label: "All",
          emitEvent: "locationSelected",
        },
      ];
    },
  },
  methods: {
    async optionSelected(event)  {
      this.isModalPrintArticleVisible = false;
      let useLocation = (event == 'cashierSelected');
      const data = await ArticleService.printReportArticles(useLocation);
      if (data && !data.error) {
        await this.$store.dispatch("print", data);
      } else {
        this.$store.commit(SET_MESSAGE_MODAL, data);
      }
    },
    showModal() {
      this.isModalPrintArticleVisible = true;
    },
    cancelModalPrintArticle() {
      console.log("cancelModalPrintArticle");
      this.isModalPrintArticleVisible = false;
    },
    closeModalPrintArticle() {
      this.isModalPrintArticleVisible = false;
    },
    resetCurrentShift() {
      this.$store.commit(SET_SHIFT_CURRENT_ACTION, null);
    },
    toggleStaffs(status) {
      if (!this.shift) {
        this.$store.commit(
          SET_MESSAGE_MODAL,
          this.$gettext("Please start shift")
        );
      } else {
        let url = "/staffs";
        if (status === true) {
          url += "-in";
        } else if (status === false) {
          url += "-out";
        }

        if (this.$router.currentRoute.path === url) {
          return this.$router.push({ name: "order" });
        }
        this.$store.state.staff.staffPage = status;
        return this.$router.push({ path: url });
      }
    },
    confirmStartDay() {
      if (!this.isCashier) {
        this.$store.commit(
          SET_MESSAGE_MODAL,
          this.$gettext("Permission denied")
        );
        return;
      }
      this.$store.commit(SET_CONFIRM_MODAL, {
        action: this.$gettext("start work day"),
        context: this,
        func: this.startDay,
      });
    },
    async endDay() {
      if (!this.isCashier) {
        this.$store.commit(
          SET_MESSAGE_MODAL,
          this.$gettext("Permission denied")
        );
        return;
      }
      const response = await DayService.checkShift();
      if (response && response.result) {
        this.$router.push({ name: "end-of-day" });
      }
    },
    startShift() {
      if (!this.isCashier) {
        this.$store.commit(
          SET_MESSAGE_MODAL,
          this.$gettext("Permission denied")
        );
        return;
      }
      if (!this.workDay) {
        this.$store.commit(
          SET_MESSAGE_MODAL,
          this.$gettext("Please start day")
        );
        return;
      }
      this.$store.commit(SET_SHIFT_CURRENT_ACTION, "start");
      this.$router.push({ name: "cash-calc" });
    },
    endShift() {
      if (!this.isCashier || this.shift.user !== this.user.id) {
        this.$store.commit(
          SET_MESSAGE_MODAL,
          this.$gettext("Permission denied")
        );
        return;
      }
      this.$store.commit(SET_SHIFT_CURRENT_ACTION, "end");
      this.$router.push({ name: "cash-calc" });
    },
    async printArticleLocation() {
      console.log("print for this location");
      console.log(this.user.station);
      this.isModalPrintArticleVisible = true;
      /*       const data = await ArticleService.printReportArticles();
      if (data && !data.error) {
        await this.$store.dispatch("print", data);
      } else {
        this.$store.commit(SET_MESSAGE_MODAL, data);
      } */
    },
    async printArticleStation() {
      console.log("print for this station");

      const data = await ArticleService.printReportArticles(true);
      if (data && !data.error) {
        await this.$store.dispatch("print", data);
      } else {
        this.$store.commit(SET_MESSAGE_MODAL, data);
      }
    },
    ...mapMutations([TOGGLE_MENU_SIDE, START_DAY]),
  },
};
</script>
